import {PlanType} from '@product-web/api-types/plan'

export const isOnNewPricingPlan = (planType?: string) =>
    [PlanType.ESSENTIAL, PlanType.ADVANCED, PlanType.STARTER].includes((planType as PlanType) ?? '')
